import { ArticleType } from '@wix/answers-api';
import { useRouter } from 'next/router';

import {
  HELPMATE_SUPPORTED_LANGUAGES,
} from '../constants';
import { useIsAnonymousAiChatbotEnabled } from './useIsAnonymousAiChatbotEnabled';
import { useResponsive } from './useResponsive';
import { PageType } from '../types';
import { hasHideChatbotEpLabel } from '../utils/article-labels';
import { isTwinsRelated, isWixelRelated } from '../utils/excluded-categories';
import { useStore } from '../zustand/stores';

const useIsHelpCenterCopilotEnabled = () => {
  const { article } = useStore((state) => state.articleSlice);
  const itemId = useStore((state) => state.pageSlice.itemId);
  const categoriesTree = useStore(
    (state) => state.categoriesTreeSlice.categoriesTree
  );
  const { user } = useStore((state) => state.userSlice);
  const { locale } = useRouter();
  const { isMobile, isTablet } = useResponsive();
  const isAnonymousAiChatbotEnabled = useIsAnonymousAiChatbotEnabled();

  if (!user && isAnonymousAiChatbotEnabled) {
    return false;
  }

  if (
    !isMobile &&
    !isTablet &&
    !article?.title?.includes('Wix Twins') &&
    article?.type === ArticleType.ARTICLE &&
    !(article && hasHideChatbotEpLabel(article)) &&
    !isTwinsRelated(
      PageType.Article,
      categoriesTree,
      itemId,
      article?.categoryId
    ) &&
    !isWixelRelated(
      PageType.Article,
      categoriesTree,
      itemId,
      article?.categoryId
    ) &&
    (HELPMATE_SUPPORTED_LANGUAGES.includes(locale as string))
  ) {
    return true;
  }
  return false;
};

export default useIsHelpCenterCopilotEnabled;
